import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const auth = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("ap_token", data.token);
        if (data.is_new_user) {
          try {
            const { trackCompleteRegistration } = await import("@/lib/pixel");
            trackCompleteRegistration({ method: "google" });
          } catch { /* pixel opcional */ }
        }
        toast.success(`Bem-vindo(a), ${data.user.name}!`);
        // Hard redirect so the AuthProvider rebootstraps with the new token.
        window.location.href = data.user.role === "admin" ? "/admin" : "/dashboard";
      } catch (e) {
        toast.error(formatApiError(e));
        window.location.href = "/login";
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <Loader2 className="animate-spin text-[#8B5CF6]" size={40} />
      <p className="mt-4 text-slate-600">Entrando com Google...</p>
    </div>
  );
}
